"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DocumentContent = void 0;
var _commonFormFields = require("@ori/common-form-fields");
var _react = require("react");
var _reactHookForm = require("react-hook-form");
var _Localization = require("../../Localization");
var _defaultTranslations_simplifiedRegistrationBrandPartner = require("../../constants/defaultTranslations_simplified-registration-BrandPartner");
var _contexts = require("../../contexts");
var _models = require("../../models");
var _api = require("../../models/api");
var _Uploader = require("../Uploader");
var _DocumentActions = require("./DocumentActions");
var _DocumentHistory = require("./DocumentHistory");
var _DocumentLoadingProgress = require("./DocumentLoadingProgress");
var _DocumentStyledComponents = require("./DocumentStyledComponents");
var _jsxRuntime = require("react/jsx-runtime");
const DocumentContent = props => {
  const {
    documentIds,
    documentTypeId,
    deleteConfirmationRequired,
    documentType,
    editableDocument,
    documentInpuName,
    configDocument,
    documentIsRequired,
    handleDocumentsChange
  } = props;
  const isTemporaryDocument = true;
  const hasDocuments = documentIds.length > 0;
  const [isHistoryExpanded, setIsHistoryExpanded] = (0, _react.useState)(false);
  const [isUploading, setIsUploading] = (0, _react.useState)(false);
  const [isUploadFinished, setIsUploadFinished] = (0, _react.useState)(false);
  const [filesInProgress, setFilesInProgress] = (0, _react.useState)([]);
  const [fetchKey, setFetchKey] = (0, _react.useState)('');
  const {
    watch
  } = (0, _reactHookForm.useFormContext)();
  const values = watch();
  const {
    data: documentsInfoData
  } = (0, _api.useCustomerDocumentsInfos)(fetchKey);
  const {
    errorData
  } = (0, _contexts.useFormError)();
  const {
    customErrors
  } = errorData;
  const isDeleteConfirmationRequired = deleteConfirmationRequired ?? false;
  const setDefaultState = () => {
    setIsHistoryExpanded(false);
    setIsUploading(false);
    setIsUploadFinished(false);
  };
  const removeFile = fileKey => {
    setDefaultState();
    setFilesInProgress(previousState => previousState.filter(documentData => documentData.document.documentId !== fileKey));
  };
  const fileUploadFinished = fileUploadResult => {
    const {
      isSuccess,
      fileKey,
      message
    } = fileUploadResult;
    if (!isSuccess && fileKey < 0 && Boolean(message)) {
      setDefaultState();
      setFilesInProgress(previousState => previousState.map(documentData => {
        const copyDocumentData = {
          ...documentData
        };
        if (copyDocumentData.document.documentId === fileKey) {
          copyDocumentData.errorMessage = message;
        }
        return copyDocumentData;
      }));
    }
  };
  const uploadProgress = (progress, fileKey) => {
    setDefaultState();
    setFilesInProgress(previousState => previousState.map(documentData => {
      const copyDocumentData = {
        ...documentData
      };
      if (copyDocumentData.document.documentId === fileKey) {
        copyDocumentData.uploadProgress = progress;
      }
      return copyDocumentData;
    }));
  };
  const uploadStart = files => {
    const negativeOne = -1;
    // eslint-disable-next-line unicorn/prefer-spread -- we want this writing
    const uploadFilesInProgress = Array.from(files).map((file, key) => ({
      document: {
        documentId: (key + 1) * negativeOne,
        fileName: file.name,
        fileSize: file.size
      },
      isDeleteConfirmationRequired: false
    }));
    setFilesInProgress(uploadFilesInProgress);
    setIsUploading(true);
  };
  const showUploadFinishedMessage = () => {
    setIsUploadFinished(true);
    setIsUploading(false);
    const messageHideTimeout = 2000;
    setTimeout(() => {
      setIsUploadFinished(false);
      setIsUploading(false);
    }, messageHideTimeout);
  };
  const triggerDocumentsChange = propertyDocumentIds => {
    if (handleDocumentsChange) {
      handleDocumentsChange(propertyDocumentIds);
    }
  };
  const uploadFinished = result => {
    showUploadFinishedMessage();
    setFetchKey(Date.now().toString());
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions -- TODO we must fixed and checked correct working in separate story
    const uploadedDocuments = result.uploadedFiles.filter(d => d.documentId && d.documentId > 0 && d.isSuccess);
    if (uploadedDocuments.length === 0) {
      return;
    }
    const uploadedDocumentIds = uploadedDocuments.map(d => d.documentId ?? 0);
    const correctDocumentIds = documentIds.length > 0 ? documentIds : [];
    const newDocumentIds = documentType?.allowMultipleDocuments ? [...correctDocumentIds, ...uploadedDocumentIds] : uploadedDocumentIds.slice(0, 1);
    triggerDocumentsChange(newDocumentIds);
    uploadedDocuments.forEach(d => removeFile(d.fileKey));
  };
  const removeDocument = documentId => {
    const newDocuments = documentIds.filter(id => id !== documentId);
    triggerDocumentsChange(newDocuments);
  };
  const getInfoByType = (typeId, includeTemporary) => documentsInfoData?.filter(info => {
    const isTemporary = includeTemporary ?? false;
    return info.documentTypeId === typeId && (!info.isTemporary || isTemporary);
  }).sort((a, b) => {
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions -- TODO we must fixed and checked correct working in separate story
    if (a.createdDate.getTime() && b.createdDate.getTime()) {
      return a.createdDate.getTime() - b.createdDate.getTime();
    }
    return 0;
  });
  const getDocuments = () => {
    if (documentIds.length === 0) {
      return [];
    }
    const items = documentsInfoData ? getInfoByType(documentTypeId, isTemporaryDocument) : [];
    const documentItems = items.filter(document => documentIds.includes(document.documentId) && (0, _DocumentActions.isDocumentPending)(document)).map(document => (0, _DocumentActions.mapToDocumentItemProps)(document, Boolean(editableDocument), true, isDeleteConfirmationRequired, removeDocument));
    return documentItems;
  };
  const renderDocuments = () => {
    const getfilesInProgress = (0, _DocumentActions.getFilesInProgress)(filesInProgress, removeFile);
    const documents = getDocuments();
    const documentsToRender = [...documents, ...getfilesInProgress];
    if (documentsToRender.length > 0) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_DocumentStyledComponents.StyledListPending, {
        children: documentsToRender.map(_DocumentActions.renderDocumentItem)
      });
    }
    return null;
  };
  const handleToggleClick = () => {
    setDefaultState();
    setIsHistoryExpanded(!isHistoryExpanded);
  };
  let fileInputProps = {
    isTemporary: isTemporaryDocument,
    handleFileUploaded: fileUploadFinished,
    handleUploadFinished: uploadFinished,
    handleUploadStart: uploadStart,
    handleFileUploadProgress: uploadProgress,
    inputName: documentInpuName,
    isRequired: documentIsRequired
  };
  if (documentType) {
    fileInputProps = {
      ...fileInputProps,
      accept: documentType.supportedMimeTypes,
      documentTypeId: documentType.documentTypeId,
      maxFileSize: documentType.maxDataSize,
      isMultiple: documentType.allowMultipleDocuments
    };
  }
  const uploaderDocument = () => editableDocument ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_DocumentStyledComponents.StyledDivUploader, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_DocumentStyledComponents.StyledDivFileInput, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Uploader.Uploader, {
        ...fileInputProps
      })
    })
  }) : null;
  const documentCardTypeField = /*#__PURE__*/(0, _jsxRuntime.jsx)(_commonFormFields.SelectFormFieldByConfig, {
    name: "identityCard.cardType",
    label: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
      id: _models.TranslationKey.ThirdStep_DocumentType,
      defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.ThirdStep_DocumentType
    }),
    title: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
      id: _models.TranslationKey.ThirdStep_ChooseDocumentType,
      defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.ThirdStep_ChooseDocumentType
    }),
    placeholder: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
      id: _models.TranslationKey.ThirdStep_ChooseDocumentType,
      defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.ThirdStep_ChooseDocumentType
    }),
    ...configDocument?.cardType,
    isMandatory: configDocument?.cardType?.validation?.isMandatory
  });
  const documentCardNumberField = /*#__PURE__*/(0, _jsxRuntime.jsx)(_commonFormFields.TextFormFieldByConfig, {
    name: "identityCard.cardNumber",
    label: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
      id: _models.TranslationKey.ThirdStep_DocumentNumber,
      defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.ThirdStep_DocumentNumber
    }),
    ...configDocument?.cardNumber,
    isMandatory: configDocument?.cardNumber?.validation?.isMandatory,
    maxLengthLimit: configDocument?.cardNumber?.validation?.maxLength,
    customErrors: customErrors
  });
  const disabledForIdentityCardTypes = configDocument?.expiration?.disabledForIdentityCardTypes;
  const disableExpirationField = disabledForIdentityCardTypes?.find(cardType => cardType === values.identityCard?.cardType);
  const expirationDocumentField = !disableExpirationField && /*#__PURE__*/(0, _jsxRuntime.jsx)(_commonFormFields.DatePickerField, {
    name: "identityCard.expiration",
    label: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
      id: _models.TranslationKey.ThirdStep_ExpirationDate,
      defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.ThirdStep_ExpirationDate
    }),
    ...configDocument?.expiration,
    isMandatory: configDocument?.expiration?.validation?.isMandatory,
    minDate: configDocument?.expiration?.validation?.minValue,
    maxDate: configDocument?.expiration?.validation?.maxValue,
    customErrors: customErrors
  });
  const documents = renderDocuments();
  const uploader = uploaderDocument();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [documentCardTypeField, documentCardNumberField, expirationDocumentField, /*#__PURE__*/(0, _jsxRuntime.jsxs)(_DocumentStyledComponents.StyledDivWrapper, {
      ownerState: {
        hasDocuments
      },
      children: [uploader, /*#__PURE__*/(0, _jsxRuntime.jsx)(_DocumentLoadingProgress.DocumentLoadingProgress, {
        uploading: isUploading,
        uploadFinished: isUploadFinished
      }), documents, documentIds.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsx)(_DocumentHistory.DocumentHistory, {
        temporaryDocument: isTemporaryDocument,
        historyExpanded: isHistoryExpanded,
        documentIds: documentIds,
        documentTypeId: documentTypeId,
        handleToggleClick: handleToggleClick,
        documentPending: _DocumentActions.isDocumentPending,
        mapToDocumentItemProps: _DocumentActions.mapToDocumentItemProps,
        deleteConfirmationRequired: isDeleteConfirmationRequired,
        removeDocument: removeDocument,
        histroyDocumentsInfoData: documentsInfoData
      })]
    })]
  });
};
exports.DocumentContent = DocumentContent;